<ng-container *ngFor="let footButton of footerContent">
    <acl-ngx-button [variant]="footButton.variant" [compact]="footButton.compact"
        [ultraCompact]="footButton.ultraCompact" [focus]="footButton.focus" [dark]="footButton.dark"
        [error]="footButton.error" [disabled]="footButton.disabled" [label]="footButton.label" [icon]="footButton.icon"
        [iconPosition]="footButton.iconPosition" (click)="closeModal(footButton.onConfirm)">
    </acl-ngx-button>
</ng-container>
<ng-container *ngIf="!footerContent || !footerContent.length">
    <acl-ngx-button [variant]="defaultButton.variant" [label]="defaultButton.label" (click)="closeModal()">
    </acl-ngx-button>
</ng-container>